module.exports = __webpack_public_path__ + "img/3049a20d1d95344999548811c216b7a5.png";